import { Icon } from '../../../../layout/Icon.jsx';

export function ConfirmSeedModal({ open, onClose, onConfirm, loading }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/40 z-50 grid place-items-center p-4"
    >
      <div className="bg-white rounded-[14px] shadow-pop w-full max-w-[440px] overflow-hidden">
        <div className="px-5 py-4 border-b border-line flex items-center justify-between">
          <h3 className="font-extrabold text-[15px] m-0">تأكيد إنشاء البيانات التجريبية</h3>
          <button type="button" onClick={onClose} disabled={loading} className="text-ink-3 hover:text-ink">
            <Icon name="x" size={18} />
          </button>
        </div>

        <div className="p-5">
          <p className="text-[13px] text-ink-2 leading-relaxed mb-3">
            سيتم إنشاء بيانات تجريبية كاملة (مخازن، منتجات، أطفال، جلسات، فواتير، مصاريف).
          </p>
          <ul className="text-[12px] text-ink-2 list-disc pr-5 space-y-0.5 mb-4">
            <li>3 مخازن + 8 أقسام + 23 منتجاً</li>
            <li>12 ولي أمر + 18 طفلاً</li>
            <li>25 كارت RFID</li>
            <li>5 جلسات نشطة + 3 جلسات منتهية</li>
            <li>فواتير POS + فاتورة شراء + مصاريف</li>
          </ul>
          <div className="text-[11.5px] text-yellow-700 bg-yellow-50 border border-yellow-200 rounded-[8px] px-3 py-2">
            هذه العملية لا تمسح أي شيء — تضيف فقط بيانات جديدة.
          </div>
        </div>

        <div className="px-5 py-3 border-t border-line flex items-center justify-end gap-2 bg-paper-2">
          <button type="button" className="btn" onClick={onClose} disabled={loading}>
            إلغاء
          </button>
          <button type="button" className="btn btn-primary" onClick={onConfirm} disabled={loading}>
            {loading ? 'جاري الإنشاء…' : 'تأكيد وإنشاء'}
          </button>
        </div>
      </div>
    </div>
  );
}
